import {useMarketingConsent} from "./useMarketingConsent";

export const MarketingConsentRedirectWrapper = () => {
    useMarketingConsent();
    return null;
};
